import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { usePartnerUIContext } from "./PartnerUIContext";
import PartnerTable from "./partner-table/PartnerTable";
import { PartnerFilter } from "./partner-filter/PartnerFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const PartnerCard = () => {
  const partnerUIContext = usePartnerUIContext();
  const partnerUIProps = useMemo(() => {
    return {
      newPartnerButtonClick: partnerUIContext.newPartnerButtonClick,
    };
  }, [partnerUIContext]);

  return (
    <Card>
      <CardHeader title="Mitra">
        <CardHeaderToolbar>
          {BlockOrg() && RoleChecker("Create", "mitra") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={partnerUIProps.newPartnerButtonClick}
            >
              Tambah Mitra
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <PartnerFilter />
        <PartnerTable />
      </CardBody>
    </Card>
  );
};
